import { useCallback, useEffect, useRef } from 'react';

import { GAME_CARD_ID_PREFIX } from '../components/GamesList/constants';
import { HOME_CATEGORY_ID } from '../stores/categories/CategoriesStore';
import { useStores } from '../stores/useStores';

const HIGHLIGHT_DURATION_MS = 4000;
const MAX_MOUNT_FRAMES = 20;

export function useScrollToGame(): (gameId: number) => void {
  const { categoriesStore } = useStores();
  const highlightTimeout = useRef<ReturnType<typeof setTimeout> | number>(0);

  useEffect(() => () => clearTimeout(highlightTimeout.current), []);

  return useCallback(
    (gameId: number) => {
      if (categoriesStore.currentId !== HOME_CATEGORY_ID) return;

      const categoryId = categoriesStore.categoriesIds.find((id) =>
        categoriesStore.categoriesRegistry[id]?.subCategoryGames.some((game) => game.masterCasinoGameId === gameId),
      );
      if (categoryId == null) return;
      categoriesStore.markCategoryEager(categoryId);

      const row = document.querySelector<HTMLElement>(`[data-category-id="${categoryId}"]`);
      row?.scrollIntoView({ behavior: 'smooth', block: 'center' });

      let frames = 0;
      const findAndScroll = () => {
        const card = document.querySelector<HTMLElement>(`#${GAME_CARD_ID_PREFIX}${gameId}`);
        if (card) {
          card.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
          card.classList.add('game-card-highlight');
          clearTimeout(highlightTimeout.current);
          highlightTimeout.current = setTimeout(() => {
            card.classList.remove('game-card-highlight');
            highlightTimeout.current = 0;
          }, HIGHLIGHT_DURATION_MS);
          return;
        }
        if (frames++ < MAX_MOUNT_FRAMES) requestAnimationFrame(findAndScroll);
      };
      requestAnimationFrame(findAndScroll);
    },
    [categoriesStore],
  );
}
